import React from 'react';
import { Switch, Route } from 'react-router-dom';

// Import actual page components
import Home from '../pages/Home';
import About from '../pages/About';
import Products from '../pages/Products';
import Gallery from '../pages/Gallery';
import Contact from '../pages/Contact';

const Routes = () => {
  return (
    <Switch>
      <Route exact path="/" component={Home} />
      <Route path="/about" component={About} />
      <Route path="/products" component={Products} />
      <Route path="/gallery" component={Gallery} />
      <Route path="/contact" component={Contact} />
    </Switch>
  );
};

export default Routes;